import { render, staticRenderFns } from "./AppMain.vue?vue&type=template&id=4fdd58e2&scoped=true"
import script from "./AppMain.vue?vue&type=script&lang=js"
export * from "./AppMain.vue?vue&type=script&lang=js"
import style0 from "./AppMain.vue?vue&type=style&index=0&id=4fdd58e2&scoped=true&lang=css"
import style1 from "./AppMain.vue?vue&type=style&index=1&id=4fdd58e2&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdd58e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fdd58e2')) {
      api.createRecord('4fdd58e2', component.options)
    } else {
      api.reload('4fdd58e2', component.options)
    }
    module.hot.accept("./AppMain.vue?vue&type=template&id=4fdd58e2&scoped=true", function () {
      api.rerender('4fdd58e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/AppMain.vue"
export default component.exports